import { Fragment } from 'react';
import { formatBuildVersion } from '@/lib/build-version';

const INSTITUTIONAL_LINKS = [
  { label: 'Privacidade', href: 'https://vertice.finance/privacidade' },
  { label: 'Termos', href: 'https://vertice.finance/termos' },
  { label: 'Suporte', href: 'mailto:support@vertice.finance' },
] as const;

export function AppFooter() {
  const version = formatBuildVersion({
    sha: typeof __BUILD_ID__ !== 'undefined' ? __BUILD_ID__ : 'dev',
    builtAt: typeof __BUILT_AT__ !== 'undefined' ? __BUILT_AT__ : '',
    tag: typeof __BUILD_TAG__ !== 'undefined' ? __BUILD_TAG__ : '',
  });
  const year = new Date().getFullYear();

  return (
    <footer className="mt-12 space-y-1.5 pt-6 text-center text-2xs text-text-secondary">
      <nav
        aria-label="Links institucionais"
        className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1"
      >
        {INSTITUTIONAL_LINKS.map((link, i) => (
          <Fragment key={link.href}>
            {i > 0 && (
              <span aria-hidden className="opacity-50">
                ·
              </span>
            )}
            <a
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              className="cursor-pointer transition-colors hover:text-text-primary hover:underline"
            >
              {link.label}
            </a>
          </Fragment>
        ))}
      </nav>
      <p>© {year} Vértice · Brasil · v{version}</p>
    </footer>
  );
}
